import {
  DataTableSortableColumn,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  TooltipTrigger,
  TooltipContent,
  DropdownMenu,
  Typography,
  ColumnDef,
  Tooltip,
  Button,
  Badge,
} from '@ui/components';
import { VehicleTableDataDto } from '@interfaces/models';
import { MenuVertical } from '@ui/components/icons';
import { TFunction } from 'i18next';

export const getImportVehiclesColumns = (
  t: TFunction,
  onEditVehicle: (vehicle: VehicleTableDataDto) => void,
  onRemoveVehicle: (vehicle: VehicleTableDataDto) => void,
): ColumnDef<VehicleTableDataDto>[] => [
  {
    accessorKey: 'registrationNumber',
    header: ({ column }) => {
      return (
        <DataTableSortableColumn
          label={t('ONBOARDING.IMPORT_VEHICLES.TABLE_HEADER_PLATE_NUMBER')}
          column={column}
        />
      );
    },
  },
  {
    accessorKey: 'name',
    maxSize: 300,
    header: ({ column }) => {
      return (
        <DataTableSortableColumn
          label={t('ONBOARDING.IMPORT_VEHICLES.TABLE_HEADER_NAME')}
          column={column}
        />
      );
    },
  },
  {
    accessorKey: 'registrationCountry',
    header: ({ column }) => {
      return (
        <DataTableSortableColumn
          label={t('ONBOARDING.IMPORT_VEHICLES.TABLE_HEADER_COUNTRY_CODE')}
          column={column}
        />
      );
    },
  },
  {
    accessorKey: 'vehicleCategory',
    maxSize: 300,
    header: ({ column }) => {
      return (
        <DataTableSortableColumn
          label={t('ONBOARDING.IMPORT_VEHICLES.TABLE_HEADER_CATEGORY')}
          column={column}
        />
      );
    },
    cell: ({ row }) => {
      return t(`VEHICLE_CATEGORY.${row.original.vehicleCategory}`);
    },
  },
  {
    accessorKey: 'labels',
    header: t('ONBOARDING.IMPORT_VEHICLES.TABLE_HEADER_LABEL'),
    cell: ({ row }) => {
      const labels = row.original.labels ?? [];
      const labelCount = labels.length;

      if (!labelCount) {
        return '-';
      }

      return (
        <div className="flex items-center gap-1 whitespace-nowrap">
          <Badge size="large" outlined>
            {labels[0]?.name}
          </Badge>
          {labelCount > 1 && (
            <Tooltip>
              <TooltipTrigger>
                <Badge size="large" outlined icon>
                  +{labelCount - 1}
                </Badge>
              </TooltipTrigger>
              <TooltipContent className="bg-background flex gap-2 w-auto max-w-[15rem] flex-wrap">
                {labels.map((label) => (
                  <Badge key={label.id} size="large" outlined>
                    {label.name}
                  </Badge>
                ))}
              </TooltipContent>
            </Tooltip>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: 'actions',
    header: '',
    size: 100,
    cell: ({ row }) => {
      const rowData = row.original;

      return (
        <div className="flex justify-end">
          <DropdownMenu>
            <Tooltip>
              <TooltipTrigger tabIndex={-1} asChild>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost">
                    <MenuVertical />
                  </Button>
                </DropdownMenuTrigger>
              </TooltipTrigger>
              <TooltipContent className="w-auto">
                <Typography variant="labelXSmallBook">
                  {t('ONBOARDING.IMPORT_VEHICLES.TABLE_MORE_ACTIONS')}
                </Typography>
              </TooltipContent>
            </Tooltip>
            <DropdownMenuContent className="w-56">
              <DropdownMenuItem onClick={() => onEditVehicle(rowData)}>
                {t('ONBOARDING.IMPORT_VEHICLES.TABLE_EDIT_VEHICLE')}
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onRemoveVehicle(rowData)}>
                {t('ONBOARDING.IMPORT_VEHICLES.TABLE_DELETE_VEHICLE')}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      );
    },
  },
];
